<template>
	<div class="flex w-full flex-col py-3 hover:bg-slate-50 px-4">
		<div>
			<div class="flex flex-row gap-2 justify-between">
				<p :class="['font-bold text-sm leading-tight', 'text-black']">
					{{ symbol }}
				</p>

				<span class="max-w-[100px] h-6">
					<stock-block-chart
						:current-net-change="net_chg"
						:data="{ prices, labels }"
					></stock-block-chart>
				</span>
			</div>

			<p
				:class="[
					'text-sm overflow-hidden text-ellipsis whitespace-nowrap max-w-[130px]',
					'text-black'
				]"
			>
				{{ name }}
			</p>
		</div>

		<div>
			<p
				:class="[
					'text-sm font-semibold',
					theme === 'dark' ? 'text-white' : 'text-black'
				]"
			>
				{{ price?.toFixed(2) || 0 }}
			</p>
			<p
				class="text-sm"
				:class="{
					'text-success': pc_chg && pc_chg >= 0,
					'text-negative': pc_chg && pc_chg <= 0,
					'text-slate-400': !pc_chg || pc_chg == 0
				}"
			>
				{{ net_chg?.toFixed(2) }}
				<span>({{ pc_chg?.toFixed(2) || 0 }}%)</span>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import StockBlockChart from "./stock-block-chart.vue";

defineProps({
	size: {
		type: String,
		default: "md"
	},
	theme: {
		type: String,
		default: "light"
	},
	symbol: {
		type: String
	},
	name: {
		type: String
	},
	pc_chg: {
		type: Number
	},
	net_chg: {
		type: Number
	},
	price: {
		type: Number
	},
	labels: {
		type: Array,
		required: true
	},
	prices: {
		type: Array,
		required: true
	}
});

const onImgError = (e: any) => {
	console.log("onImgError", e.target.src);
	const newSrc = e.target.src.replace(".svg", ".png");
	e.target.src = newSrc;
};

onMounted(() => {});
</script>

<style scoped>
.stock-info-card {
	@apply rounded-2xl bg-slate-100/[0.2] p-4 flex flex-col justify-between gap-2;
}
</style>
